import styles from "./styles/vocal-remover-advantages.module.scss";
import advantage1Image from "@/assets/vocal-remover/vocal-remover-advantage-1.webp";
import advantage2Image from "@/assets/vocal-remover/vocal-remover-advantage-2.webp";
import advantage3Image from "@/assets/vocal-remover/vocal-remover-advantage-3.webp";
import advantage4Image from "@/assets/vocal-remover/vocal-remover-advantage-4.webp";
import advantage5Image from "@/assets/vocal-remover/vocal-remover-advantage-5.webp";
import advantage6Image from "@/assets/vocal-remover/vocal-remover-advantage-6.webp";
import VocalRemoverAdvantageInfo from "@/components/pages/vocal-remover/components/vocal-remover-advantages/vocal-remover-advantage-info";

const VocalRemoverAdvantages = () => {
  return (
    <div className={styles.wrapper}>
      <div className={styles.title}>
        Advantages of the <span>Acapella Extractor</span>
      </div>
      <div className={styles.advantages_wrapper}>
        <VocalRemoverAdvantageInfo
          image={advantage1Image.src}
          title={"Advanced AI Technology"}
          description={
            "Our tool uses smart algorithms to do the heavy lifting. It’s like having a digital expert who quickly and intelligently separates vocals from music, making the process seamless for you."
          }
        />
        <VocalRemoverAdvantageInfo
          image={advantage3Image.src}
          title={"Instant Online Access"}
          description={
            "There’s no software to download or install. Just visit our website, upload your file, and start using it right away. Easy access from any device with an internet connection."
          }
        />
        <VocalRemoverAdvantageInfo
          image={advantage4Image.src}
          title={"High Precision Separation"}
          description={
            "The tool does a fantastic job of separating vocals clearly and cleanly from the instrumental part. You’ll get professional-quality results with minimal fuss."
          }
        />
        <VocalRemoverAdvantageInfo
          image={advantage5Image.src}
          title={"No Sign-In Required"}
          description={
            "You can start extracting vocals from your music immediately – no sign-up or login is necessary."
          }
        />
        <VocalRemoverAdvantageInfo
          image={advantage6Image.src}
          title={"Direct Link Support"}
          description={
            "You can directly input online links, including videos, for processing. This unique feature saves time by bypassing the need to download and upload files manually."
          }
        />
      </div>
    </div>
  );
};

export default VocalRemoverAdvantages;
